export default __webpack_public_path__ + "static/media/jeechallenger_icon.7b8a695a.svg";